import * as React from 'react';
import { createBrowserRouter, RouterProvider, RouteObject } from 'react-router-dom';
import routeTreeConfig from '@/config/routes';
import { PageLoading } from '@ant-design/pro-components';
import MircoAppLoading from '@/MicroAppLoading';
import Restricted from '../Permission/Restricted';


// 生成路由树
function generateRouteObjectTree(configArr: any[]): RouteObject[] {
  return configArr.map((config) => {
    const LazyComponent = React.lazy(config.component);
    return {
      ...config,
      element: config.component ? (
        <Restricted
          path={config.path}
          requiredPermission={config.permission}
        >
          <LazyComponent />
        </Restricted>
      ) : undefined,
      children: config.children
        ? generateRouteObjectTree(config.children)
        : undefined
    };
  });
}

const router = createBrowserRouter(generateRouteObjectTree(routeTreeConfig), { basename: window.__MICRO_APP_BASE_ROUTE__ || '/' });

const RouteTree = () => {
  return (
    <React.Suspense fallback={window.__MICRO_APP_ENVIRONMENT__ ? <MircoAppLoading /> : <PageLoading />}>
      <RouterProvider router={router} />
    </React.Suspense>
  );
};

export default RouteTree;
